var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2867 0.233398H22.1859C9.98526 0.233398 0.0947266 10.1268 0.0947266 22.331V22.4319C0.0947266 34.6361 9.98526 44.5295 22.1859 44.5295H22.2867C34.4873 44.5295 44.3778 34.6361 44.3778 22.4319V22.331C44.3778 10.1268 34.4873 0.233398 22.2867 0.233398Z",
    fill: "url(#paint0_linear_168_203)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0871 9.24536H15.3847C11.5992 9.24536 8.51953 12.3259 8.51953 16.1126V28.652C8.51953 32.4386 11.5992 35.5192 15.3847 35.5192H29.0871C32.8727 35.5192 35.9523 32.4386 35.9523 28.652V16.1126C35.9523 12.3259 32.8727 9.24536 29.0871 9.24536ZM10.9414 16.1126C10.9414 13.6621 12.935 11.6679 15.3847 11.6679H29.0871C31.5369 11.6679 33.5305 13.6621 33.5305 16.1126V28.652C33.5305 31.1024 31.5369 33.0967 29.0871 33.0967H15.3847C12.935 33.0967 10.9414 31.1024 10.9414 28.652V16.1126Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2354 28.7685C25.7556 28.7685 28.6212 25.9037 28.6212 22.3808C28.6212 18.858 25.7572 15.9932 22.2354 15.9932C18.7136 15.9932 15.8496 18.858 15.8496 22.3808C15.8496 25.9037 18.7136 28.7685 22.2354 28.7685ZM22.2354 18.4172C24.4214 18.4172 26.1994 20.1957 26.1994 22.3824C26.1994 24.569 24.4214 26.3475 22.2354 26.3475C20.0494 26.3475 18.2714 24.569 18.2714 22.3824C18.2714 20.1957 20.0494 18.4172 22.2354 18.4172Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2127 17.0251C30.1607 17.0251 30.9333 16.2538 30.9333 15.3041C30.9333 14.3543 30.1622 13.583 29.2127 13.583C28.2633 13.583 27.4922 14.3543 27.4922 15.3041C27.4922 16.2538 28.2633 17.0251 29.2127 17.0251Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_168_203",
    x1: 6.56428,
    y1: 38.0581,
    x2: 37.9175,
    y2: 6.71564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#DD2A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#9537B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515BD4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/Insta.76b7e5cb461207492189cef2b0e9080b.svg";
export { ForwardRef as ReactComponent };